/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TheContextMenu.vue?vue&type=template&id=1e965558"
import script from "./TheContextMenu.vue?vue&type=script&lang=js"
export * from "./TheContextMenu.vue?vue&type=script&lang=js"
import style0 from "./TheContextMenu.vue?vue&type=style&index=0&id=1e965558&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports